export class Trip {
  id: number;
  schoolId: number;
  busId: number;
  activationCode: string;
  departureDate: string;
  returnDate: string;
  title: string;
  infos: string;
  destLat: number;
  destLng: number;
  // school
  // bus
  // tripMessages

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/trip.ts